export const childrensHaircuts = [
    {
        id: 1,
        image: "images/servicesImages/childrensHaircuts1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/childrensHaircuts2.webp",
    },
    {
        id: 3,
        image: "images/servicesImages/childrensHaircuts3.webp",
    },
]


export const hotBotox = [
    {
        id: 1,
        image: "images/servicesImages/hotBotox1.webp",
        description: "Салон Нія",
    },
]

export const womensHaircuts = [
    {
        id: 1,
        image: "images/servicesImages/womensHaircuts1.webp",
        description: "Нові процедури в салоні",
    },
    {
        id: 2,
        image: "images/servicesImages/womensHaircuts2.webp",
        description: "Нові процедури в салоні",
    },
]

export const cauterization = [
    {
        id: 1,
        image: "images/servicesImages/cauterization1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/cauterization2.webp",
    },
]

export const hairstyles = [
    {
        id: 1,
        image: "images/servicesImages/hairstyles1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/hairstyles2.webp",
    },
    {
        id: 3,
        image: "images/servicesImages/hairstyles3.webp",
    },
]

export const keratinSmoothing = [
    {
        id: 1,
        image: "images/servicesImages/keratinSmoothing1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/keratinSmoothing2.webp",
    },
]

export const intensiveRecovery = [
    {
        id: 1,
        image: "images/servicesImages/intensiveRecovery1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/intensiveRecovery2.webp",
    },
]

export const coldBotox = [
    {
        id: 1,
        image: "images/servicesImages/coldBotox1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/coldBotox2.webp",
    },
    {
        id: 3,
        image: "images/servicesImages/coldBotox3.webp",
    },
    {
        id: 4,
        image: "images/servicesImages/coldBotox4.webp",
    },
]

export const mensHaircuts = [
    {
        id: 1,
        image: "images/servicesImages/mensHaircuts1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/mensHaircuts2.webp",
    },
]

export const dyeing = [
    {
        id: 1,
        image: "images/servicesImages/dyeing1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/dyeing2.webp",
    },
    {
        id: 3,
        image: "images/servicesImages/dyeing3.webp",
    },
    {
        id: 4,
        image: "images/servicesImages/dyeing4.webp",
    },
    {
        id: 5,
        image: "images/servicesImages/dyeing5.webp",
    },
    {
        id: 6,
        image: "images/servicesImages/dyeing6.webp",
    },
]

export const pedicureWithCoating = [
    {
        id: 1,
        image: "images/servicesImages/pedicureWithCoating1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/pedicureWithCoating2.webp",
    },
]

export const modeling = [
    {
        id: 1,
        image: "images/servicesImages/modeling1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/modeling2.webp",
    },
    {
        id: 3,
        image: "images/servicesImages/modeling3.webp",
    },
    {
        id: 4,
        image: "images/servicesImages/modeling4.webp",
    },
]

export const varnishCoating = [
    {
        id: 1,
        image: "images/servicesImages/varnishCoating1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/varnishCoating2.webp",
    },
    {
        id: 3,
        image: "images/servicesImages/varnishCoating3.webp",
    },
    {
        id: 4,
        image: "images/servicesImages/varnishCoating4.webp",
    },
]

export const perm = [
    {
        id: 1,
        image: "images/servicesImages/perm1.webp",
    },
    {
        id: 2,
        image: "images/servicesImages/perm2.webp",
    },
    {
        id: 3,
        image: "images/servicesImages/perm3.webp",
    },
]

export const eveningMakeup = [
    {
        id: 1,
        image: "images/servicesImages/eveningMakeup1.webp",
    },
]